import { render, staticRenderFns } from "./userPlanList.vue?vue&type=template&id=cbc20956&"
import script from "./userPlanList.vue?vue&type=script&lang=js&"
export * from "./userPlanList.vue?vue&type=script&lang=js&"
import style0 from "./userPlanList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports